/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { forwardRef } from "react";

import { css, cx } from "@panda/css";

const cardThumbnailOverlayStyles = css({
	inset: 0,
	position: "absolute",
	zIndex: 1,
	// borderRadius: "inherit",
});

export type CosmosCardThumbnailOverlayProps = {
	aspectRatio?: "16/9" | "5/3" | "1/1";
	className?: string;
	children: React.ReactNode;
};

export const CosmosCardThumbnailOverlay = forwardRef(
	(
		{ className, children, ...props }: CosmosCardThumbnailOverlayProps,
		forwardedRef: React.Ref<HTMLDivElement>,
	): React.JSX.Element => {
		return (
			<div
				{...props}
				className={cx("cosmos-card__thumbnail-overlay", cardThumbnailOverlayStyles, className)}
				ref={forwardedRef}
			>
				{children}
			</div>
		);
	},
);

CosmosCardThumbnailOverlay.displayName = "CosmosCard.ThumbnailOverlay";
